<template>
  <div class="booking-details">
    <div class="card">
      <div class="card-header">
        <h2 class="my-3">Details van het verblijf</h2>
      </div>
    </div>

    <accommodation v-show="filterProducts('ShortStay').length" :products="filterProducts('ShortStay')" />

    <booking-pitches v-show="filterProducts('ShortStay').length" />

    <guests v-show="filterProducts('Guest').length || stay.guests?.length" :products="filterProducts('Guest')" />

    <tourist-taxes v-show="filterProducts('TouristTax').length || stay.touristTaxes?.length" :products="filterProducts('TouristTax')" />

    <electricities v-show="filterProducts('Electricity').length || stay.electricities?.length" :products="filterProducts('Electricity')" />

    <other-products v-show="filterProducts('Product').length || stay.products?.length" :products="filterProducts('Product')" />
  </div>
</template>

<script>
import config from "@/config";
import { mapState, mapGetters } from "vuex";

import Accommodation from "@/components/booking-details/Accommodation";
import Guests from "@/components/booking-details/Guests";
import TouristTaxes from "@/components/booking-details/TouristTaxes";
import Electricities from "@/components/booking-details/Electricities";
import OtherProducts from "@/components/booking-details/OtherProducts";
import BookingPitches from "@/components/booking-details/Pitches";

import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const ProductRepository = RepositoryFactory.get("ProductRepository");

export default {
  components: {
    OtherProducts,
    Electricities,
    TouristTaxes,
    Accommodation,
    Guests,
    BookingPitches
  },

  props: {
    id: { type: Number, default: null }
  },

  data: function () {
    return {
      config: config,
      products: []
    };
  },

  computed: {
    ...mapState("CurrentBooking", { booking: "booking", stay: "selectedStay" }),
    ...mapState("Campsites", ["currentCampsite"]),
    ...mapGetters({
      getBookingQueryType: "CurrentBooking/getBookingQueryType"
    })
  },

  mounted() {
    ProductRepository.getProducts(this.currentCampsite.id, this.getBookingQueryType(this.id))
      .then((response) => {
        this.products = response.data;
      })
      .catch((error) => {
        this.$notify({
          group: "app",
          type: "error",
          title: this.$i18n.t("general_error_title"),
          text: error.response.data.message
        });
      });
  },

  methods: {
    filterProducts: function (d) {
      return this.products.filter((p) => p.productDefinition === d);
    }
  }
};
</script>
